import { BodyText, Label } from "nhsuk-react-components"
import React from "react"
import { Helmet } from "react-helmet"
import { Routes } from "../../../global/enums"

const SuccessView = () => (
  <>
    <Helmet>
      <title>Registration Complete | NHS England applications</title>
    </Helmet>
    <Label isPageHeading>Your registration is complete</Label>
    <BodyText>You may now access NHS England applications.</BodyText>
    <BodyText>
      <a id="loginLink" href={Routes.Authentication}>
        Log in to NHS England applications
      </a>
    </BodyText>
  </>
)

export default SuccessView
